// extracted by mini-css-extract-plugin
export default {"cta":"dE-z","disabled":"eE-z"};